module.exports = __webpack_public_path__ + "static/add_todoist_instructions-89db74d022566df146c71761668df3b1.png";